import { useCallback } from "react";
import { useState } from "react";

export const usePaginatedData = () => {
  const [rows, setRows] = useState([]);
  const [pages, setPages] = useState(0);

  const handleReset = useCallback(() => {
    setRows([]);
    setPages(0);
  }, []);

  return { rows, pages, setRows, setPages, reset: handleReset };
};
